import { getConfig } from '@superbet-group/web.lib.config';
import {
    createRestClient,
    processResponse,
} from '@superbet-group/web.lib.rest';
import { IResponse } from '@superbet-group/web.lib.utilities';

import { defaultHttpTimeoutMs } from '@core/constants';
import { mapBanner } from './BannerMapper';
import BannerDto from './BannerDto';
import { BannerDirectus } from '@src/federations/shared/cms/types/Banner';
import {
    getCmsLocalePath,
    getCmsUrl,
} from '@core/services/cms/utils';
import { logger } from '@src/app/logger';
import { getPlatformParameter } from '../types/common';

export function createBannersService() {
    const restClient = createRestClient(getConfig().cms?.baseUrl ?? '', defaultHttpTimeoutMs);
    const platform = getPlatformParameter();

    async function getBanners(category: string, screen = 'home'): Promise<BannerDirectus[]> {
        const response: IResponse<BannerDto[]> = await processResponse(restClient.get(
            getCmsUrl({
                path: '/banners',
                queryParams: {
                    target: getCmsLocalePath(),
                    location: categoryMapper[category] ?? category, // let other federations control over location
                    screen,
                    platform,
                },
            }),
        ));
        return response.data.map((banner) => {
            try {
                return mapBanner(banner);
            } catch (e) {
                logger.error(e as Error);
                return null;
            }
        }).filter((banner) => banner !== null) as BannerDirectus[];
    }

    return {
        getBanners,
    };
}

const categoryMapper: Record<string, string> = {
    promotions: 'sportsBanners',
    quickLinks: 'sportsQuickLinks',
    promotedTournaments: 'sportsSidebar',
    promotionsV2: 'sportsBannersV2',
    registration: 'registration',
};
